import * as React from 'react';
import Svg, { Path,Rect } from 'react-native-svg';

function HeadPhone(props: any) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
			
			<Path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.198 11.084c0 .08-.03.173-.057.26-.254.774-.765 1.3-1.532 1.573-.082.029-.114.07-.13.15-.213 1.03-.976 1.792-2.003 1.988-.18.035-.368.04-.553.044-.313.006-.627.004-.94 0-.072-.001-.104.02-.128.091-.245.72-.738 1.188-1.488 1.312-1.119.184-2.008-.482-2.222-1.48a1.903 1.903 0 011.606-2.309 1.903 1.903 0 012.053 1.185c.031.078.068.105.152.104.361-.005.722.01 1.082-.005.592-.024 1.016-.315 1.271-.85a.353.353 0 00.02-.046l.006-.054c-.081 0-.16.007-.237-.002-.116-.013-.239-.017-.342-.063a.481.481 0 01-.298-.466c-.002-1.557-.002-3.114 0-4.672 0-.303.236-.533.54-.538.183-.003.365-.006.547.001.092.004.112-.029.11-.115a4.553 4.553 0 00-1.026-2.863c-.724-.899-1.661-1.462-2.797-1.653-1.493-.252-2.82.137-3.944 1.154-.798.72-1.267 1.63-1.439 2.69-.037.225-.04.455-.056.684-.002.029.005.059.008.102.22 0 .435-.004.65 0a.522.522 0 01.498.333.554.554 0 01.044.214c.003 1.548.003 3.095.002 4.642a.54.54 0 01-.546.544c-.367-.001-.738.023-1.1-.022-1.003-.123-1.674-.684-2.023-1.628a2.16 2.16 0 01-.125-.763c.002-.293-.004-.586.002-.88.02-1.015.483-1.757 1.39-2.216.079-.04.105-.082.103-.167a5.625 5.625 0 01.678-2.835 5.672 5.672 0 012.57-2.46c.617-.3 1.27-.482 1.953-.543 1.1-.098 2.15.092 3.129.606 1.675.88 2.689 2.263 3.041 4.12.071.373.065.763.088 1.145.004.065.02.103.081.132.722.342 1.173.904 1.358 1.681.005.019.004.165.004.216v1.659zm-2.644-2.665V11.68c0 .277 0 .277.279.271a1.32 1.32 0 001.317-1.34c0-.297.002-.593-.002-.89a1.402 1.402 0 00-.031-.28c-.143-.647-.73-1.129-1.563-1.022zM4.487 8.4c-.184.01-.363.006-.536.035-.581.1-1.039.645-1.047 1.234-.004.33-.006.66 0 .99.01.47.222.833.612 1.088.295.193.625.226.97.197V8.4zm4.536 7.039a.825.825 0 10.006-1.65.825.825 0 00-.006 1.65z'
				fill={props.color || '#1D2939'}
			/>
		</Svg>
	);
}

export default HeadPhone;
